import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';

import SecondSideBarInner from './../../shared/secondSideBarInner'
import SecondSideBarHeader from './../sides/secondSideBarHeader'
import ClearCarsFilter from './../sections/cars/clearCarsFilter'

import styles from './sideSecondBar.module.scss'

const SideSecondBar = props => {
  const { isOpen, title, handleClick } = props

  return (
    <div className={isOpen ? styles.sideSecondBar_open : styles.sideSecondBar_closed}>

      <SecondSideBarInner>
        <SecondSideBarHeader title={title} handleClose={handleClick}>

          <ClearCarsFilter />

        </SecondSideBarHeader>
      </SecondSideBarInner>

      <div className={styles.container_sideSecondContent}>
        <Scrollbars
          style={{ height: "100%" }}
          autoHide={true}
        >
          {props.children}
        </Scrollbars>
      </div>

    </div>
  )
}

export default React.memo(SideSecondBar)
